import ApiError from '~/types/ApiError';

export const SPOOFING_NOT_ALLOWED_MESSAGE =
  "Spoofing is not allowed either because you don't have the required role or the target user's roles don't allow spoofing.";

export function createSpoofingNotAllowedError() {
  return new ApiError({
    message: SPOOFING_NOT_ALLOWED_MESSAGE,
    name: 'SpoofingNotAllowedError',
    status: 403,
  });
}

export function isSpoofingNotAllowedError(error: unknown): error is ApiError {
  return error instanceof ApiError && error.name === 'SpoofingNotAllowedError';
}
